<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      รายละเอียดครอบครัว (FAMILY DATA)
    </v-card-title>
    <v-card-text class="pt-2">
      <v-row class="pt-2">
        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_fat_name"
            label="ชื่อบิดา"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_occ_fat"
            :items="$store.getters.get_Occupation"
            item-text="occ_description"
            item-value="occ_id"
            label="อาชีพบิดา"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_age_fat"
            label="อายุ"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_stat_fat"
            :items="$store.getters.get_LivingState"
            item-text="lvt_name"
            item-value="lvt_id"
            label="สถานะภาพ"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_mot_name"
            label="ชื่อมารดา"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_occ_mot"
            :items="$store.getters.get_Occupation"
            item-text="occ_description"
            item-value="occ_id"
            label="อาชีพมารดา"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_age_mot"
            label="อายุ"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_stat_mot"
            :items="$store.getters.get_LivingState"
            item-text="lvt_name"
            item-value="lvt_id"
            label="สถานะภาพ"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_sum_sis_bro"
            label="จำนวนพี่น้อง"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_no_child"
            label="ท่านเป็นบุตรคนที่"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_status"
            :items="$store.getters.get_Status"
            item-text="tea_status_name"
            item-value="tea_status_id"
            label="สถานภาพสมรส"
          ></v-select>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="pt-0 pb-0"
          v-if="$store.state.dataFrm.tea_status !== 'S'"
        >
          <v-text-field
            v-model="$store.state.dataFrm.tea_spouse_name"
            label="ชื่อ-นามสกุล (คู่สมรส)"
            v-if="$store.state.dataFrm.tea_status !== 'S'"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_spouse_age"
            label="อายุ"
            type="number"
            v-if="$store.state.dataFrm.tea_status !== 'S'"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_spouse_occ"
            :items="$store.getters.get_Occupation"
            item-text="occ_description"
            item-value="occ_id"
            label="อาชีพ"
            v-if="$store.state.dataFrm.tea_status !== 'S'"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_spouse_occ_address"
            label="สถานที่ทำงาน"
            v-if="$store.state.dataFrm.tea_status !== 'S'"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_sum_child"
            label="จำนวนบุตร"
            type="number"
            v-if="$store.state.dataFrm.tea_status !== 'S'"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_sum_child_male"
            label="ชาย"
            type="number"
            v-if="$store.state.dataFrm.tea_status !== 'S'"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_sum_child_female"
            label="หญิง"
            type="number"
            v-if="$store.state.dataFrm.tea_status !== 'S'"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {
      tea_birthday: "",
      tea_sex: "",
    };
  },
 props: {
   label: {
      type: String,
      default: "",
    },
 },
  computed: {
    Computed_PreName() {
      return this.$store.state.dataFrm.tea_sex == "M"
        ? this.$store.getters.get_PreName.filter((val) => val.pre_id == "01")
        : this.$store.state.dataFrm.tea_sex == "F"
        ? this.$store.getters.get_PreName.filter(
            (val) => val.pre_id == "02" || val.pre_id == "03"
          )
        : [];
    },
  },
};
</script>

<style lang=""></style>
